import Tab from 'react-bootstrap/Tab'
import Tabs from 'react-bootstrap/Tabs'
import Layout from '../../../../brands/components/Layout'
import { useNavigate } from 'react-router-dom'
import Training from './trainings'
import Request from './request'

const EmpDetails: React.FC = () => {
    const navigate = useNavigate()
    return (
        <Layout>
            <div className="row">
                <div className="col-sm-6">
                    <h4>John Doe</h4>
                </div>
                <div className="col-sm-6">
                    <div className="custom-btn-design">
                        <a
                            onClick={() => {
                                navigate('/dashboard/view')
                            }}
                            className="button button-primary button-align-right"
                        >
                            BACK
                        </a>
                    </div>
                </div>
            </div>
            <Tabs
                defaultActiveKey="details"
                id="uncontrolled-tab-example"
                className="mb-3 custom-tabs"
            >
                <Tab eventKey="details" title="Trainings Completed">
                    <Training />
                </Tab>
                <Tab eventKey="profile" title="Time-Off Requests">
                    <Request />
                </Tab>
            </Tabs>
        </Layout>
    )
}

export default EmpDetails
